import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FurnizoriProiecteComponent } from './furnizori-proiecte.component';
import { AddFurnizoriProiecteComponent } from './add-furnizori-proiecte/add-furnizori-proiecte.component';
import { EditFurnizoriProiecteComponent } from './edit-furnizori-proiecte/edit-furnizori-proiecte.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';



@NgModule({
    declarations: [
        FurnizoriProiecteComponent,
        AddFurnizoriProiecteComponent,
        EditFurnizoriProiecteComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [FurnizoriProiecteComponent]
})
export class FurnizoriProiecteModule { }
